import { useEffect } from "react";
import {
  useLocation,
  Link,
  Routes,
  Route,
  Outlet,
  useNavigate,
} from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import { IoMdArrowRoundBack } from "react-icons/io";
//Templates

import UpdateUser from "./UpdateUser";
import { Tabs, Tab, BigBoldText } from "../../../settings/setting.style";
import UserPassword from "../UserPassword/UserPassword";
import RoleAssignment from "../RoleAssignment/RoleAssignment";
import { useStoreWrapper } from "../../../../../store/store";
import styled from "styled-components";
import ActionBtnU from "../../components/ActionBtnU";

const UserStatusInfo = styled.button`
  display: flex;
  color: red;
  border: 0;
  background: transparent;
  cursor: pointer;
`;
const DisabledIcon = styled(FiAlertTriangle)`
  color: red;
  font-size: 1.5em;
  margin: 0 5px 0 5px;
`;

const BackButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media screen and (min-width: 961px) {
    margin-right: 1rem;
  }
  @media screen and (max-width: 435px) {
    margin-top: 1rem;
  }
`;
const UserManagement = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { selectedUser, setSelectedUser } = useStoreWrapper((state) => ({
    selectedUser: state.selectedUser,
    setSelectedUser: state.setSelectedUser,
  }));

  // Handle navigation and cleanup in one place
  useEffect(() => {
    if (!selectedUser?.userId && pathname.includes("user-management")) {
      navigate("/user/users");
    }
  }, [selectedUser, pathname]);

  const handleBack = () => {
    setSelectedUser(null);
    navigate("/user/users");
  };

  const btnLinkStyle = {
    textDecoration: "none",
    color: "inherit",
  };

  return (
    <>
      <BackButtonContainer>
        <ActionBtnU purple_border onClick={handleBack}>
          <span className="mr-2 mt-1 font-bold">
            {" "}
            <IoMdArrowRoundBack />
          </span>
          Back
        </ActionBtnU>{" "}
      </BackButtonContainer>

      <BigBoldText>User Management</BigBoldText>

      {selectedUser?.status !== "Active" && (
        <UserStatusInfo style={{ textDecoration: "underline" }}>
          <Link
            style={btnLinkStyle}
            to="/user/users/user-management/role-assignment"
          >
            User Deactivated
          </Link>
          <DisabledIcon />
        </UserStatusInfo>
      )}
      <Tabs>
        <Link style={btnLinkStyle} to="/user/users/user-management">
          <Tab
            className="h5 text-md flex h-12 w-fit items-center justify-center font-medium"
            isActive={pathname === "/user/users/user-management"}
          >
            User Profile
          </Tab>
        </Link>

        <Link
          style={btnLinkStyle}
          to="/user/users/user-management/user-password"
        >
          <Tab
            className="h5 text-md flex h-12 w-fit items-center justify-center font-medium"
            isActive={pathname === "/user/users/user-management/user-password"}
          >
            User Password
          </Tab>
        </Link>
        <Link
          style={btnLinkStyle}
          to="/user/users/user-management/role-assignment"
        >
          <Tab
            className="h5 text-md flex h-12 w-fit items-center justify-center font-medium"
            isActive={
              pathname === "/user/users/user-management/role-assignment"
            }
          >
            {" "}
            Role Assignment
          </Tab>
        </Link>
      </Tabs>
      <Outlet />
      <div className="mt-5">
        <Routes>
          <Route
            path="/"
            element={<UpdateUser selectedUser={selectedUser} />}
          />
          <Route path="user-password" element={<UserPassword />} />
          <Route path="role-assignment" element={<RoleAssignment />} />
        </Routes>
      </div>
    </>
  );
};

export default UserManagement;
